<template>
  <main class="login-page">
    <section class="login-visual">
    </section>

    <section class="login-panel">
      <t-card class="login-card" :bordered="false">
        <div class="login-card__head">
          <h2>登录后台</h2>
          <p>请输入管理员账号和密码进入控制台。</p>
        </div>
        <t-form :data="form" label-align="top" @submit="login">
          <t-form-item label="账号" name="username">
            <t-input
              v-model="form.username"
              clearable
              placeholder="请输入账号"
              autocomplete="username"
            >
              <template #prefixIcon><user-icon /></template>
            </t-input>
          </t-form-item>
          <t-form-item label="密码" name="password">
            <t-input
              v-model="form.password"
              type="password"
              clearable
              placeholder="请输入密码"
              autocomplete="current-password"
            >
              <template #prefixIcon><lock-on-icon /></template>
            </t-input>
          </t-form-item>
          <t-button
            class="login-submit"
            block
            theme="primary"
            type="submit"
            size="large"
            :loading="loading"
          >
            登录
          </t-button>
        </t-form>
      </t-card>
    </section>
  </main>
</template>

<script>
import axios from '../axios';
import { MessagePlugin } from 'tdesign-vue-next';
import { LockOnIcon, UserIcon } from 'tdesign-icons-vue-next';
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'UserLogin',
  components: {
    LockOnIcon,
    UserIcon,
  },
  setup() {
    const form = reactive({
      username: '',
      password: '',
    });
    const loading = ref(false);
    const store = useStore();
    const router = useRouter();

    const login = async ({ e }) => {
      e?.preventDefault();

      if (!form.username || !form.password) {
        MessagePlugin.error('账号和密码不能为空');
        return;
      }

      const isChinese = /[\u4e00-\u9fa5]/;
      if (isChinese.test(form.username) || isChinese.test(form.password)) {
        MessagePlugin.error('账号和密码不能包含中文');
        return;
      }

      if (form.username.length < 6 || form.password.length < 6) {
        MessagePlugin.error('账号和密码长度不能少于 6 位');
        return;
      }

      loading.value = true;
      try {
        const response = await axios.post('/index.php?action=login', {
          username: form.username,
          password: form.password,
        });

        if (response.data.code === 200) {
          localStorage.setItem('user-token', response.data.token);
          store.dispatch('login', {
            username: response.data.user.username,
            types: response.data.user.types,
            owner: response.data.user.owner,
            balance: response.data.user.balance,
            createNum: response.data.user.createNum,
            balanceZS: response.data.user.balanceZS,
            createNumZS: response.data.user.createNumZS,
          });
          MessagePlugin.success(response.data.message || '登录成功');
          router.push({ name: 'HomePage' });
        } else {
          MessagePlugin.error(response.data.message || '登录失败');
        }
      } catch (error) {
        MessagePlugin.error('登录失败，请稍后再试');
      } finally {
        loading.value = false;
      }
    };

    return {
      form,
      loading,
      login,
    };
  },
};
</script>

<style scoped>
.login-page {
  display: grid;
  min-height: 100vh;
  grid-template-columns: minmax(0, 1.05fr) minmax(420px, 0.95fr);
  background: #f5f7fb;
}

.login-visual {
  position: relative;
  min-height: 100vh;
  padding: 42px;
  overflow: hidden;
  color: #fff;
  background:
    linear-gradient(125deg, rgba(0, 34, 78, 0.9), rgba(0, 82, 217, 0.78)),
    url('https://images.unsplash.com/photo-1550745165-9bc0b252726f?auto=format&fit=crop&w=1600&q=80')
      center / cover;
}

.login-visual::after {
  position: absolute;
  inset: auto 0 0;
  height: 35%;
  content: '';
  background: linear-gradient(180deg, rgba(0, 0, 0, 0), rgba(0, 20, 46, 0.62));
}

.login-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.74), rgba(247, 249, 252, 0.96)),
    radial-gradient(circle at 80% 16%, rgba(0, 82, 217, 0.12), transparent 36%);
}

.login-card {
  width: min(100%, 430px);
  border-radius: 8px;
  border: 1px solid rgba(226, 232, 240, 0.88);
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.14);
}

.login-card :deep(.t-card__body) {
  padding: 34px;
}

.login-card__head {
  margin-bottom: 26px;
}

.login-card__head h2 {
  margin: 0 0 8px;
  color: #111827;
  font-size: 28px;
  line-height: 1.2;
  letter-spacing: 0;
}

.login-card__head p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.7;
}

.login-card :deep(.t-form__item) {
  margin-bottom: 18px;
}

.login-card :deep(.t-form__label) {
  padding-bottom: 7px;
  color: #334155;
  font-weight: 600;
}

.login-card :deep(.t-input) {
  height: 44px;
  border-color: #dbe3ef;
  background: #fbfdff;
}

.login-card :deep(.t-input:hover),
.login-card :deep(.t-input.t-is-focused) {
  border-color: #0052d9;
  background: #fff;
}

.login-card :deep(.t-input__prefix-icon) {
  color: #64748b;
}

.login-submit {
  height: 46px;
  margin-top: 14px;
  font-weight: 700;
}

@media (max-width: 860px) {
  .login-page {
    display: block;
    background:
      linear-gradient(145deg, rgba(0, 34, 78, 0.92), rgba(0, 82, 217, 0.82)),
      url('https://images.unsplash.com/photo-1550745165-9bc0b252726f?auto=format&fit=crop&w=1200&q=80')
        center / cover;
  }

  .login-visual {
    min-height: auto;
    padding: 24px 22px 0;
    background: transparent;
  }

  .login-visual::after {
    display: none;
  }

  .login-panel {
    align-items: flex-start;
    padding: 28px 18px 32px;
    background: transparent;
  }

  .login-card :deep(.t-card__body) {
    padding: 24px;
  }

  .login-card__head h2 {
    font-size: 24px;
  }

}
</style>
